// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"4589a7d5","59":"e68c6640","210":"765d6a8f","212":"3cbf79e1","269":"680e5060","329":"f1e9bfcb","670":"356f805d","780":"5d55a8b3","875":"217dd3c7","955":"cf5c91a0"}[chunkId] + ".chunk.js";
};